// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomDialog_root__3FF_f","paper":"CustomDialog_paper__1AW81"};